import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FaqAccordion() {
  const faqs = [{
    q: '¿Sirve tanto para primaria como para secundaria?',
    a: 'Sí. Cada tomo y cada bono incluye versiones y adaptaciones específicas para ambos niveles. Las plantillas aplican al sistema costarricense en su totalidad, independientemente del nivel en que enseñés.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el enlace de descarga. El acceso es instantáneo. En menos de 5 minutos tenés todo el material en tu dispositivo.'
  }, {
    q: '¿Qué lo diferencia de los recursos que encuentro gratis online?',
    a: 'Todo el contenido fue diseñado específicamente para el sistema educativo público costarricense. Los formularios son los del MEP. Los comités son los del MEP costarricense. Los protocolos respetan la normativa vigente. Los guiones están pensados para el contexto cultural costarricense. No es material genérico adaptado. Es material creado para este sistema.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Siete días completos desde la compra. Si no es lo que esperabas, escribís a reconectacontigohoy506@gmail.com y recibís la devolución completa sin preguntas. Sin formularios complicados. Sin tiempos de espera largos.'
  }, {
    q: '¿Puedo editar las plantillas?',
    a: 'Todas las plantillas están diseñadas para ser copiadas en Google Docs o Word y editadas libremente según tu centro educativo, nivel y grupo. Son tuyas para adaptar.'
  }, {
    q: '¿Funciona si ya llevo años en el sistema?',
    a: 'Especialmente si ya llevás años. El MegaPack no te enseña pedagogía básica. Te da sistemas para lo que ya hacés pero que todavía no tiene estructura: el papeleo, los comités, los grupos difíciles, los padres, los domingos de ansiedad. Cuanto más años en el sistema, más inmediato es el alivio.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-stone-50" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <h2 className="text-3xl font-black text-center text-stone-900 mb-12" data-id="element-115">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-116">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-stone-200 rounded-xl overflow-hidden shadow-sm" data-id="element-117">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between font-bold text-stone-800 hover:bg-stone-50 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-inset" aria-expanded={openIndex === i} data-id="element-118">
                <span data-id="element-119">{faq.q}</span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-600 flex-shrink-0 ml-4" data-id="element-120" /> : <Plus className="w-5 h-5 text-stone-400 flex-shrink-0 ml-4" data-id="element-121" />}
              </button>
              <AnimatePresence data-id="element-122">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-123">
                    <div className="px-6 pb-5 text-stone-600 leading-relaxed border-t border-stone-100 pt-3" data-id="element-124">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}